<template>
    <div class="contact-links-wrapper d-sm-none">
        <a href="tel:+4915221072554">
            <icon-component :icon="fa_phone_alt()"></icon-component>
        </a>
        <a :href="getWhatsappLink()">
            <icon-component :icon="fa_whatsapp()" height="1.1em" width="1.1em" viewBox="-50 0 512 512"></icon-component>
        </a>
        <a href="sms:+4915221070532">
            <i class="text-content">SMS</i>
        </a>
        <a href="mailto:info@erobella.com">
            <icon-component :icon="fa_envelope()"></icon-component>
        </a>
    </div>
</template>

<script>
import {fa_envelope, fa_phone_alt, fa_whatsapp} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import {getWhatsappLink} from "@/core/utils/helpers/whatsappHelper";

export default {
    components: {IconComponent},
    methods: {fa_whatsapp, fa_phone_alt, fa_envelope, getWhatsappLink},
    computed: {
        ...mapState(['settings']),
    },
    mounted() {
    },
};
</script>
